import type { ApiMethods as ClientAuthApiMethods } from "@skanska/vsa-client-auth";

export const ApiMethods = {
  Get: "GET" as ClientAuthApiMethods,
  Post: "POST" as ClientAuthApiMethods,
  Patch: "PATCH" as ClientAuthApiMethods,
  Put: "PUT" as ClientAuthApiMethods,
  Delete: "DELETE" as ClientAuthApiMethods,
} as const;
